// import node module libraries
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Card, ListGroup, Container, Alert } from 'react-bootstrap';
import axios from 'axios';

// import sub components
import HeaderBreadcrumb from '../HeaderBreadcrumb';
import ArticlesCategoryCard from './ArticlesCategoryCard';
import SEO from 'components/marketing/seo/Seo';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// import MDI icons
import Icon from '@mdi/react';
import { mdiArrowRight } from '@mdi/js';

// import data files
//import GuidesResourcesData from 'data/marketing/help-center/GuidesResourcesData';

const HelpCenterGuide = () => {
	const [GuidesResources, setGuidesResources] = useState([]);
	const [isLoadingGuidesResources, setIsLoadingGuidesResources] = useState(true);

	const breadcrumb = [
		{
			page: 'Help Center',
			link: '/marketing/help-center/'
		},
		{
			page: 'Guides & Resources',
			link: '#'
		}
	];

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoadingGuidesResources(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/guides`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setGuidesResources(
					responseData
				);
				setIsLoadingGuidesResources(false);
			})
			.catch((error) => {
				setIsLoadingGuidesResources(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<Fragment>
			<SEO
				title="Help Center Guides & Resources"
				description="Finde Anleitungen zu Funktionen, Integrationen & Preisen. Entdecke hilfreiche Ressourcen oder kontaktiere unser Support-Team. Schnelle Hilfe rund um die Multi-Channel Plattform."
				keywords="guides saas plattform, support multi channel e-commerce"
				canonical="https://haeppy.app/marketing/help-center/guide/"
			/>
			{/* header and breadcrumb */}
			<HeaderBreadcrumb title="Guides & Resources" breadcrumb={breadcrumb} />
			{/* articles category listing cards */}
			<section className="py-10">
				<Container>
					<Row>
						<Col md={{ offset: 2, span: 8 }} xs={12}>
							<Row>
								{isLoadingGuidesResources || GuidesResources && GuidesResources.length == 0 ? (
									<>
										{Array.from({ length: 6 }).map((_, idx) => (
											<Col lg={6} xs={12} key={idx}>
												<Card className="border mb-4">
													<Card.Body className="p-5">
														{/* category title and description  */}
														<div className="mb-5">
															<h2 className="fw-semi-bold"><Skeleton height="40px" /></h2>
															<Skeleton height="15px" count={2} />
														</div>
														{/* articles list  */}
														<ListGroup as="ul" bsPrefix="list-unstyled">
															<ListGroup.Item as="li" className="mb-2" bsPrefix=" ">
																<Skeleton height="10px" count={6} />
															</ListGroup.Item>
														</ListGroup>
													</Card.Body>
													<Card.Footer>
														<Skeleton height="10px" count={1} />
													</Card.Footer>
												</Card>
											</Col>
										))}
									</>
								) : (
									GuidesResources.map((item, index) => {
										// Filter out categories with no articles
										if (item.guides.length === 0 || item.guide_category_slug === 'draft') {
											return null; // Skip rendering this category
										}
										return (
											<Col lg={6} xs={12} key={index}>
												<ArticlesCategoryCard item={item} />
											</Col>
										);
									})
								)}
							</Row>
						</Col>
					</Row>
				</Container>
			</section>
		</Fragment>
	);
};
export default HelpCenterGuide;
